// EINV_MSGS
export const COMMON_MSGS = {
    // EINV
    SUBMITTED: 'Submitted',
    
    REQUEST_SUBMITTED: "Request submitted successfully.",
    REQUEST_FAILED: "Request failed.",
    
    GENERATION_OF_PARTB: 'Generation of Part-B is allowed for IRN generated invoices only',
    UPDATE_EWAYBILL: 'Update E-Way Bill is allowed for IRN generated invoice',
    
    ENTER_ENTITY_GSTIN_RETURN_PERIOD: "Please select Entity, GSTIN and Return period",
    ENTER_GSTIN_RETURN_PERIOD: "Please select GSTIN and Return period",
    ENTER_ENTITY_RETURN_PERIOD: "Please select Entity and Return period",
    ENTER_ENTITY_GSTIN: "Please select Entity and GSTIN",
    ENTER_GSTIN: 'Please select GSTIN',
    ENTER_RETURN_PERIOD: "Please select Return period",
    ENTER_ENTITY: "Please select Entity",
    ENTER_DATE: "Please select date",
    ENTER_MANDATORY_FIELDS: "Select all mandatory fields",
    ENTER_ENTITY_GSTIN_RETURN_PERIOD: "Please select Entity GSTIN and Return period",
    IRN_EXISTS: 'IRN for selected invoice is already generated',
    IRN_MSG: 'IRN for selected invoices cannot be generated. Either selected invoice is cancelled or IRN is already generated',
    
    CANCELLED_INVOICE: 'Selected Invoice is Cancelled',
    PARTB_EXISTS: 'Part-B is already generated',
    TIME_EXCEEDED_INVOICE: 'Cannot Cancel Invoice, time exceeded',
    DELETE_NOT_ALLOWED: 'Delete is not allowed',
    GENERATE_PARTB: "Generate Part-B first",
    SCHEDULE_MSG: "File will be uploaded on scheduled time.",
    
    SELECT_RECORD:'Please select at least one record.',
    SAVE_RECORD: "Please save record first.",
    ROW_NOT_EDITABLE: "This Row is non editable",
    
    UPLOAD_FILE_TYPE : 'Please upload excel file only.',
    FILE_UPLOADING: "File is being uploaded...",
    FILE_DELETED: "File deleted successfully",
    FILE_ERROR: "Please upload a valid File",
    EXCEL_DOWNLOAD: "Excel can't be downloaded",
    
    NO_DATA: "No data found",
    SOMETHING_WENT_WRONG: "Something went wrong",
    DATA_SAVED: "Data saved successfully",
    DATA_RESET: "Data reset successfully",
    DATA_RESET_ERROR: "Error while resettign data",
    DATA_FETCHED: "Data fetched successfully",
    DATA_UPDATED: "Data updated successfully",
    DATA_DOWNLOADED: "Data downloaded successfully",
    ERROR_IN_SAVE: "Error while saving records",

    FIELD_NOT_EDITABLE: "This Field is not Editable",
    NUMERIC_VALUE: "Please provide numeric value (upto 2 decimal places)",
    
    PASSWORD_MSG: 'Password and Confirm Password does not match.',
    SAME_OLD_NEW_PASSWORD_MSG: `Old Password and new Password cannot be same`,

    EMAIL_INVALID: 'Please enter valid email address',
    INVALID_DESCRIPTION: "Description should be less than 255 characters",

    INVALID_GSTIN: "Please enter valid GSTIN",
    RECORD_DELETED: "Record deleted successfully"
    // B2C
    //REQ_SUBMITTED: "Request submitted successfully. You will receive a mail shortly.",

    // EWAYBILL
    //RESOLVE_ERROR: "Please resolve all the error first",
    //INVALID_SELECTION: "Invalid Selection",
    //INVOICE_NOT_CONSOLIDATED: "Selected invoice have been not consolidated",
    //ALREADY_CONSOLIDATED: "Already consolidated",
    //SELECT_TWO_RECORDS: "Please select atleast two record",

    //GSTR1

    //ENTER_GSTIN: "" in 2 EWAYBILL and GSTR1
}
export const EINV_MSGS = {
        
}

export const B2C_MSGS = {
    REQ_SUBMITTED: "Request submitted successfully. You will receive a mail shortly.",
}

export const EWAYBILL_MSGS = {
    RESOLVE_ERROR: "Please resolve all the error first",
    INVALID_SELECTION: "Invalid Selection",
    //ENTER_GSTIN: "Enter GSTIN or return period",
    UPDATE_EWAYBILL: "Update Eway Bill is not allowed",
    INVOICE_NOT_CONSOLIDATED: "Selected invoice have been not consolidated",
    ALREADY_CONSOLIDATED: "Already consolidated",
    SELECT_TWO_RECORDS: "Please select atleast two record",
    ENTER_DOCNO_DOCTYPE: "Please enter DocNo and DocType for Consigner",
    ENTER_GEN_GSTIN: "Please enter Gen Gstin",
    ENTER_STATE_CODE: "Please enter State code",
    PASSING_DATE: "Passing Date should be within last/latest 3 days, Other than current date",
    ENTER_TYPE: "Please enter Type",
    ENTER_EWB: "Please enter EWB No",
    
}

export const GSTR1_MSGS = {
    FILE_ERROR: "Please upload a valid File",
    //ENTER_GSTIN: "Please provide GSTIN and Return period",
    SUMMARY_FETCHED: "Summary fetched successfully",
    UNABLE_FETCHED:"Unable to process your request"

}

export const GSTR2A_2B_MSGS = {
    TWO_FINANCIAL_YR_ALLOWED: "Maximum two financial year allowed",
    ENTER_GSTIN: "Please select GSTIN",
    ENTER_GSTR2A_2B_PERIOD: "Please select GSTR-2A/GSTR-2B Period",
    ENTER_PR_PERIOD: "Please select PR Period",
}

export const DATA_FETCH_MSGS = {
    MULTIPLE_PERIOD_NOT_ALLOWED: "Multiple period selection should not allowed",
    MULTIPLE_FINANCIAL_YR_NOT_ALLOWED: "Multiple financial year selection should not allowed",
    SELECT_GSTIN_RETURN_LEDGE_TYPE: "Please select GSTIN, Return Period and LedgeType",
    SELECT_GSTIN_RETURN_DATA_TYPE: "Please select GSTIN, Return Period and Data Type",
    SELECT_DATA_TYPE: "Please select Data Type",
}

export const GSTR9_9C_MSGS = {
    AUTO_DRAFTED_DATA: "Auto-drafted GSTR-9 data is not available.",
    GSTR9_DOWNLOADED: "GSTR-9 downloaded successfully",
    GSTR9_NO_DATA: "No Data available to download",
    INPUT_REQUIRED: "Atleast one input required",
    
}

export const ANALYTICS_MSGS = {
    SELECT_GSTIN_RETURN_PERIOD_VENDOR: "Please select GSTIN and Return Period and Vendor Type",
    SELECT_GSTIN_RP_SUPPLY_TAX: "Please select GSTIN, Return Period, Supply Type and Tax Type",
    SELECT_GSTIN_RP_TAX: "Please select GSTIN and Return Period and Tax Type",
    SELECT_RETURN_TYPE_MT1: "Please select more than one return type",
    SELECT_GSTIN_RP_PERIODICITY: "Please select GSTIN, Return Period, Periodicity",
    SELECT_SUPPLY_TYPE: "Please select Supply Type",
    SELECT_DOCUMENT_TYPE: "Please select Document Type",
    SELECT_TAX_TYPE: "Please select Tax Type",
    SELECT_TAX_RATE_TYPE: "Please select Tax Rate Type",
    SELECT_DATA_SOURCE: "Please select Data Source",
    SELECT_TRANSACTION_TYPE: "Please select Transaction Type",
    SELECT_VENDOR: "Please select Vendor Type",
    SELECT_RETURN_TYPE: "Please select Return Type",
}

export const ADMIN_MSGS = {
    PIN_ADDED: "Pin Code Added Successfully",
    MODULE_ADDED: "Module Added Successfully",
    MODULE_DELETED: "Module Deleted Successfully",
    MODULE_REMOVED: "Module removed successfully",
    PASSWORD_MIN_LENGTH :"Password must contain minimum 8 characters",
    PASSWORD_MAX_LENGTH :  "Password can contain max 20 characters",
    PASSWORD_SPECIAL_CHAR :  "Password contain UC,LC,Special or numbers",
    COMPANY_NAME_ALPHANUMERIC : "Please enter valid company name",
    PAN_INVALID: "Please enter valid pan number",
    REP_NAME_INVALID : "Please enter valid representative name",
    FIRST_NAME_INVALID : "Please enter valid first name",
    LAST_NAME_INVALID : "Please enter valid last name",
}

export const VENDOR_MASTER_MSG = {
    GSTIN_LENGTH :"GSTIN must contain 15 characters",
    VAILD_EMAIL: "Please enter valid email",
    VAILD_PHONE: "Please enter valid phone number",
    EMAIL_COUNT: "Only enter three emails",
    VALID_NAME: "Please enter valid name",
    NAME_SIZE: "Name cannot exceed 30 characters",
    ADDRESS_SIZE: "Address cannot exceed 60 characters",
    INVALID_GSTIN: "GSTIN is not valid",
}
export const GSTR7_MSGS = {
    DATE_FORMAT : "Please enter date in MMYYYY format",
}
export const GSTR6_MSGS = {
    SUMMARY_POPUP_MSG : "Please Distribute the balance ITC to view the summary",
}

export const GSTR2A2BNEW_MSGS = {
    NO_DOWNLOAD: 'No Data available to download',
    EXCEL_DOWNLOAD_SUCCESS: 'Excel downloaded successfully',
    EXCEL_DOWNLOAD_ERROR:'Failed to download excel'
}